import { IIconsProps } from "./icons.model";

const ConsignadoIcon = (props: IIconsProps) => {
  return (
    <img
      id={props.id}
      src={"/icon/menu/consignado.svg"}
      alt=""
      style={{ width: props.fontSize, height: props.fontSize }}
    />
  );
};

export default ConsignadoIcon;
